import { CompensationDeviationTendancy } from '../enums/compensation-deviation-tendancy.enum';

export class CompensationDeviationHelper {
  public static getTendency(distribution: number): CompensationDeviationTendancy | undefined {
    if (distribution == null) {
      return undefined;
    }

    if (distribution < -2.5) {
      return CompensationDeviationTendancy.HugeGapBelow;
    }
    if (distribution < -1.25) {
      return CompensationDeviationTendancy.SmallGapBelow;
    }
    if (distribution <= 0) {
      return CompensationDeviationTendancy.InExpectationBelow;
    }
    if (distribution <= 1.25) {
      return CompensationDeviationTendancy.InExpectationAbove;
    }
    if (distribution <= 2.5) {
      return CompensationDeviationTendancy.SmallGapAbove;
    }
    return CompensationDeviationTendancy.HugeGapAbove;
  }

  public static getWarningTranslationKey(distribution: number): string | undefined {
    switch (this.getTendency(distribution)) {
      case CompensationDeviationTendancy.SmallGapBelow:
      case CompensationDeviationTendancy.HugeGapBelow:
        return 'merit-budget.hr-research.compensation-deviation.warning-below';
      case CompensationDeviationTendancy.SmallGapAbove:
      case CompensationDeviationTendancy.HugeGapAbove:
        return 'merit-budget.hr-research.compensation-deviation.warning-above';
      default:
        return undefined;
    }
  }
}
